import { tempDietaryTagMappings } from 'utils/constants';
import { CityPageFilterFragment } from 'utils/gqlReactTypings.generated.d';

export const foodOrGoodsRegex = /Food$|Goods$/;
interface DescribeFilterReturnType {
  filterDescription: string | null;
  hasFoodOrGoods: boolean;
}

// Examples: Vegan | American | Vegan American | null
export const describeFilter = (activeFilter?: CityPageFilterFragment): DescribeFilterReturnType => {
  const cuisineName = activeFilter?.cuisineCategory?.title ?? null;
  const dietaryName = activeFilter?.dietaryFilter ? tempDietaryTagMappings[activeFilter.dietaryFilter] ?? null : null;
  const filterDescription = (cuisineName || dietaryName) && `${dietaryName ?? ''} ${cuisineName ?? ''}`.trim();
  const hasFoodOrGoods = foodOrGoodsRegex.test(filterDescription ?? '');
  return { filterDescription, hasFoodOrGoods };
};
